import React, { useState } from 'react';
import { DocumentNode } from '@apollo/client';
import { Input, Spin } from 'antd';
import { get } from 'lodash';
import { Optional } from '../../util/StateArrayType';
import { usePersonFieldMutation } from '../../browse/person/Components/attributeFields/AttributeFields/usePersonFieldMutation';
import { TableFieldUpdateViewProps } from '../../browse/search_old/types';
import { ObjectToDotted } from './fieldConfigTypes';

interface RecordType {
  id: number;
  controlSetting?: Optional<{ id: number; createDcr: boolean }>;
}

type FreeTextUpdateFieldArgs<T extends RecordType, V> = {
  mutation: DocumentNode;
  valuePath: ObjectToDotted<T, string | number>;
  buildVariables: (value: string, record: T) => V;
};

export function buildFreeTextUpdateFieldConfig<T extends RecordType, V>(
  args: FreeTextUpdateFieldArgs<T, V>,
) {
  return (props: TableFieldUpdateViewProps<T>) => {
    const [text, setText] = useState(get(props.record, args.valuePath) as string);
    const { Renderer, submit, blocking } = usePersonFieldMutation<unknown, V>({
      mutation: args.mutation,
      controlSetting: props.record?.controlSetting,
      endEditing: props.endEditing
    });

    const onEndEditing = () => !blocking && props.endEditing();
    const onSaveChanges = () => !blocking && submit(args.buildVariables(text, props.record)).then(onEndEditing);


    return (
      <Renderer>
        <div style={{ position: 'relative' }}>
          <Input
            value={text}
            autoFocus
            onPressEnter={onSaveChanges}
            onBlur={onSaveChanges}
            onChange={(e) => setText(e.target.value)}
          />
          {blocking && <Spin size='small' style={{ position: 'absolute', top: '8px', right: '5px' }} />}
        </div>
      </Renderer>
    );
  };
}
